"use client";

import { useEditorFieldContext } from "./editor-context";
import { ProseMirrorEditor } from "./prosemirror-editor";

export const FocusEditor = () => {
  const {
    name,
    placeholder = "",
    setEditorInstance,
    setEditorValue,
    setImmediateTextContent,
    setInlineImageUploading,
    value,
    editorContext: { autoFocus, mode, setEditorContext },
  } = useEditorFieldContext<"body" | "gatedBody">();

  return (
    <ProseMirrorEditor
      autoFocus={autoFocus && name === "body"}
      mode={mode}
      name={name}
      placeholder={placeholder}
      setEditorInstance={setEditorInstance}
      setEditorValue={(nextValue) => setEditorValue(nextValue)}
      setFocusedField={(field) => {
        setEditorContext({
          focusedField: field as "body" | "gatedBody" | null,
        });
      }}
      setImmediateTextContent={setImmediateTextContent}
      setInlineImageUploading={setInlineImageUploading}
      setLastFocusedField={(field) => {
        setEditorContext({
          lastFocusedField: field as "body" | "gatedBody",
        });
      }}
      updateInlineImageMetadata={(updater) => {
        setEditorContext((previous) => ({
          inlineImageMetadata: updater(previous.inlineImageMetadata ?? {}),
        }));
      }}
      value={typeof value === "string" ? value : ""}
    />
  );
};
